import isArray from 'lodash/isArray'
import debug from '../core/debug'
const memory = new Map()

const script = self.document ? 'App' : 'Worker'

function free (tindex, key) {
  if (!memory.has(key)) {
    return
  }
  const { timeout } = memory.get(key)
  if (tindex >= timeout) {
    memory.delete(key)
    debug.log(`${script} cache: delete ${key}`)
  }
}

export default function cache (key, valueFn, life = 5000) {
  return new Promise((resolve, reject) => {
    /**
     * not cached, create queue
     */
    if (!memory.has(key)) {
      debug.log(`${script} cache: create ${key}`)
      memory.set(
        key,
        [{ resolve, reject }]
      )
      valueFn()
        .then(store => {
          memory.get(key).forEach(({ resolve }) => resolve(store))
          const timeout = setTimeout(() => free(0, key), life)
          memory.set(key, { store, timeout })
        })
        .catch(error => {
          memory.get(key).forEach(({ reject }) => reject(error))
          debug.log(`${script} cache: delete ${key}`)
          memory.delete(key)
        })
    /**
     * cached, unresolved, add to queue
     */
    } else if (isArray(memory.get(key))) {
      memory.set(
        key,
        [
          ...memory.get(key),
          { resolve, reject }
        ]
      )
    /**
     * cached, resolved, extend timeout
     */
    } else {
      let { store, timeout = 0 } = memory.get(key)
      timeout = setTimeout(() => free(timeout, key), life)
      memory.set(key, { store, timeout })
      resolve(store)
    }
  })
}
